const TMDB = 'https://image.tmdb.org/'
const TMDB_IMAGE = `${TMDB}t/p/`

export { TMDB, TMDB_IMAGE }
